module.exports = __webpack_public_path__ + "img/category_nationalpark.9cd2d84.png";